import { el } from "@dhx/ts-common/dom";
import { Inputs } from "./Inputs";

export class InputsGroup extends Inputs {
	toVDOM() {
		const options = this._config.options;
		const len = options.length;
		const positionEdit = [];

		for (let i = 0; i < len; i++) {
			const opt = options[i];
			positionEdit.push(
				el("label.input_element", { for: opt.id }, [
					el("input", {
						type: "text",
						name: opt.id,
						value: opt.value,
						index: i,
						class: opt.invalid ? "dhx_invalid" : "",
						_ref: this._uid + i,
						onchange: this._handlers.change,
						oninput: this._handlers.change,
					}),
					el(".input_icon_wrap", [opt.icon ? opt.icon() : el(".input_icon", opt.label)]),
				])
			);
		}
		return el(".edit-section.input_group_up", [
			el(".section-title", this._config.label),
			el(".inputs_group", [...positionEdit]),
		]);
	}
}
